import * as React from "react";

export const OverlayContext =
  React.createContext<React.Ref<HTMLDivElement>>(null);
